import './assets/main.css'
import 'ant-design-vue/dist/reset.css'
import 'v3-infinite-loading/lib/style.css'
import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from '@/plugins'
import { applyDocumentTitle, applyFavicon } from '@/utils/brand'

applyDocumentTitle()
applyFavicon()

const app = createApp(App)
registerPlugins(app)

app.mount('#app')
